// Public engine API. Pure functions with no DOM access, so the same code can
// price quotes in the browser widget, a server endpoint, or a test.

import { quoteGarments } from "./garments.js";
import { quoteTiered } from "./tiered.js";

export { quoteGarments, lineQuantity, rawBasePrice, tierUnitPrice } from "./garments.js";
export { quoteTiered, availableChoices } from "./tiered.js";
export { validateArtwork, readPngInfo, MESSAGES as ARTWORK_MESSAGES } from "./artwork.js";
export * from "./roster.js";
export { formatUSD, roundUpDollar, cents } from "./money.js";
export { piecesPerSheet, sheetFromLabel, bestOfferedUp } from "./impose.js";

const PRICERS = {
  "garment-formula": quoteGarments,
  "tiered-table": quoteTiered,
};

/** Price an order for any category config. */
export function quote(category, order) {
  const pricer = PRICERS[category.type];
  if (!pricer) throw new Error(`Unknown category type "${category.type}"`);
  return pricer(order, category);
}
